<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Listy rezerwowe</span>
        <h3 class="page-title">
          <template>Detale rezerwacji</template>
        </h3>
      </d-col>
      <d-col
        :key="dataStatusKey"
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push( data.type === 'RL_FIRST_VISIT' ? '/reservation_list/nowe-wizyty' : '/reservation_list/kontynuacje-wizyty')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-dropdown
          v-if="(data.status === 'RL_TO_ACCEPT')"
          :key="'status-button-' + dataStatusKey"
          :class="['dropdownStatus', 'mr-1', (service_idCopy === '' || service_idCopy === 0) ? 'dropdownStatusMargin': '']"
          :theme="data.status === 'RL_TO_ACCEPT' ? 'secondary' : 'success'"
          :menu-id="`dropdown-${data.id}`"
          :text="data.status === 'RL_TO_ACCEPT' ? 'Zmień status' : 'Zaakceptowane'">
          <d-dropdown-item>
            <d-button
              :disabled="(service_idCopy === '' || service_idCopy === 0)"
              style="width: 100%"
              :theme="(service_idCopy === '' || service_idCopy === 0) ? 'dark' : 'success'"
              @click="handleAccepted(data.id)"
              :menu-id="`dropdown-accepted-${data.id}`">
              Zaakceptuj
            </d-button>
            <span style="display: block; color: #c4183c" class="mt-2" v-if="(service_idCopy === '' || service_idCopy === 0)">Aby zaakceptować wniosek wybierz usługę</span>
          </d-dropdown-item>
        </d-dropdown>
        <d-button
          :key="'patient-button-' + dataStatusKey"
          theme="success"
          v-if="!data.patient_id && data.status !== 'RL_TO_ACCEPT' && !visibleButtons && data.type !== 'RL_ANOTHER_VISIT'"
          @click.prevent="getPatientToSend"
          class="mr-1">
          <i class="material-icons">person_add</i>
          Utwórz pacjenta
        </d-button>
        <d-button
          :key="dataStatusKey"
          v-if="data.status !== 'RL_TO_ACCEPT' && data.patient_id && !visibleButtons"
          :class="[data.patient_id ? 'patient-button-active' : 'patient-button-inactive']"
          :theme="data.patient_id ? 'danger' : 'dark'"
          @click.prevent="showModalInfoPatient"
          title="Podgląd">
          <template v-if="!spinnerPopup"><i class="material-icons">person_search</i><span class="ml-2">Karta pacjenta</span></template>
          <template v-else>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </template>
        </d-button>
        <d-button
          :key="'view-button-' + dataStatusKey"
          v-if="data.status !== 'RL_TO_ACCEPT' && data.patient_id && !visibleButtonsVisit"
          :class="['ml-1', (data.patient_id &&  visibleButtons) ? 'patient-button-active' : 'patient-button-inactive']"
          :theme="(data.patient_id && visibleButtons) ? 'success' : 'dark'"
          @click.prevent="getVisitValue"
          title="Podgląd">
          <template v-if="!spinnerFormPopup"> <i class="material-icons">add</i><span class="ml-2">Wyznacz termin</span></template>
          <template v-else>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </template>
        </d-button>
        <d-button
          :key="'download-button-' + dataStatusKey"
          theme="info"
          style="width: 7rem"
          :class="'ml-1 patient-button-active'"
          outline
          :disabled="downloading !== false"
          @click.prevent="download(data.id)">
          <template v-if="!downloading"><i class="material-icons">cloud_download</i><span class="ml-2">Pobierz</span></template>
          <template v-else>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </template>
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <visits-form-patient-popup
      v-if="data.patient_id"
      :on-close-popup="closeModalPatientInfo"
      :is-visible="isModalPatientInfoVisible"
      :patient-id="data.patient_id"
      :visit-id="0"
      :visit-form="isEdit"/>

    <visits-form-popup
      :key="visitsFormPopupKey"
      :close-modal="closeVisitValue"
      :show-modal="showModalVisit"
      :institutions-arr="institutions"
      :reservation="true"
      :reservation-institution="data.institution_id"
      :reservation-service="data.service_id"
      :reservation-patient="data.patient_id"
      :reservation-id="this.$route.params.id"
      :services-arr="services"/>
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <d-alert
            v-if="data.different_fields"
            show
            theme="danger">
            <span class="differentFields-text">Twoje dane nie zgadzają się z zapisem…</span>
            <d-button class="differentFields-button" :theme="'light'" @click.prevent="openBoxFunction" outline><i :class="['material-icons', !openBox ? 'differentFields-button' : 'differentFields-button--transform']">keyboard_arrow_down</i> </d-button>
            <ul :class="[openBox ? 'differentFields-ul' : 'differentFields-ul--transform']">
              <li
                v-for="(field, indexField) in data.different_fields"
                :key="'field-' + indexField"
                >
                {{ field.label }} - wartość zapisana w bazie {{ field.value}}
              </li>
            </ul>
          </d-alert>
          <d-tab title="Wnioskodawca" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Wnioskodawca
              <span class="custom-priority">
                <d-checkbox
                  inline
                  v-model="data.priorityNew"
                  toggle
                  class="checkbox-toggle-red">
                {{'Ważność wizyty: '}} <span style="font-weight: 700">{{( data.priorityNew !== true ) ? 'Nie' : 'Tak'}}</span>
              </d-checkbox>
              </span>
            </h4>
            <validation-observer ref="reservation-guardian-form" tag="form">
              <d-row>
                <d-col cols="3" md="2" lg="4">
                  <div class="form-group">
                    <validation-provider
                      :rules="'required'"
                      :name="'guardian_type'"
                      v-slot="{ errors }">
                      <div class="form-group">
                        <label class="title-box" :for="data.guardian_type">
                          Typ opiekuna:
                        </label>
                        <v-select
                          class="reservation-style reservation-style-select"
                          :options="guardianTypes"
                          :reduce="type => type.value"
                          :placeholder="'Wybierz typ...'"
                          v-model="data.guardian_type"
                          label="name">
                          <template #search="{attributes, events}">
                            <d-input
                              class="input-for-select"
                              :state="errors.length ? 'invalid' : null"
                              :required="!data.guardian_type"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.name }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="4" lg="4">
                  <div class="form-group">
                    <label for="guardian_name">
                      Imię:
                    </label>
                    <validation-provider
                      rules="required"
                      name="name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="4" lg="4">
                  <div class="form-group">
                    <label for="guardian_last_name">
                      Nazwisko:
                    </label>
                    <validation-provider
                      rules="required"
                      name="last_name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_last_name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="guardian_phone">
                      Telefon:
                    </label>
                    <validation-provider
                      rules="required|min:6"
                      name="guardian_phone"
                      v-slot="{ errors }">
                      <d-input
                        type="number"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_phone" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="guardian_email">
                      Adres e-mail:
                    </label>
                    <validation-provider
                      rules="required|min:6"
                      name="guardian_email"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_email" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="guardian_second_phone">
                      Drugi telefon:
                    </label>
                    <validation-provider
                      name="guardian_second_phone"
                      v-slot="{ errors }">
                      <d-input
                        type="number"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_second_phone" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="guardian_second_email">
                      Drugi adres e-mail:
                    </label>
                    <validation-provider
                      name="guardian_second_email"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_second_email" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <div class="form-group" v-if="false">
                <label for="guardian_pesel">
                  PESEL:
                </label>
                <validation-provider
                  name="guardian_pesel"
                  v-slot="{ errors }">
                  <d-input
                    type="number"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.guardian_pesel" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-row>
                <d-col cols="2" md="2" lg="6">
                  <div class="form-group">
                    <label for="guardian_city">
                      Miasto:
                    </label>
                    <validation-provider
                      name="guardian_city"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_city" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="2" md="2" lg="6">
                  <div class="form-group">
                    <label for="guardian_post_code">
                      Kod pocztowy:
                    </label>
                    <validation-provider
                      name="guardian_post_code"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_post_code" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="guardian_street">
                      Ulica:
                    </label>
                    <validation-provider
                      rules="required"
                      name="guardian_street"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_street" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="guardian_number_home">
                      Numer domu:
                    </label>
                    <validation-provider
                      rules="required"
                      name="guardian_number_home"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_number_home" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="guardian_number_local">
                      Numer lokalu:
                    </label>
                    <validation-provider
                      name="guardian_number_local"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        format="[0-9]{2}\-[0-9]{3}"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.guardian_number_local" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Dane dziecka">
            <h4 class="mb-3 pb-3 border-bottom">
              Dane dziecka
              <span class="custom-priority">
                <d-checkbox
                  inline
                  v-model="data.priorityNew"
                  toggle
                  class="checkbox-toggle-red">
                {{'Ważność wizyty: '}} <span style="font-weight: 700">{{( data.priorityNew !== true ) ? 'Nie' : 'Tak'}}</span>
              </d-checkbox>
              </span>
            </h4>
            <validation-observer ref="reservation-patient-form" tag="form">
              <d-row>
                <d-col cols="3" md="2" lg="4">
                  <div class="form-group">
                    <validation-provider
                      :rules="'required'"
                      :name="'sex'"
                      v-slot="{ errors }">
                      <div class="form-group">
                        <label class="title-box" :for="data.patient_sex">
                          Płeć:
                        </label>
                        <v-select
                          class="reservation-style reservation-style-select"
                          :options="sexTypes"
                          :reduce="type => type.value"
                          :placeholder="'Wybierz płeć...'"
                          v-model="data.patient_sex"
                          label="name">
                          <template #search="{attributes, events}">
                            <d-input
                              class="input-for-select"
                              :state="errors.length ? 'invalid' : null"
                              :required="!data.patient_sex"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.name }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback" style="display: block; margin-top: -0.8rem;">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="2" lg="4">
                  <div class="form-group">
                    <label for="patient_name">
                      Imię:
                    </label>
                    <validation-provider
                      rules="required"
                      name="name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="2" lg="4">
                  <div class="form-group">
                    <label for="patient_last_name">
                      Nazwisko:
                    </label>
                    <validation-provider
                      rules="required"
                      name="last_name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_last_name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="patient_birthday_date">
                      Data urodzin:
                    </label>
                    <validation-provider
                      rules="required"
                      name="birthday"
                      v-slot="{ errors }">
                      <d-input
                        type="date"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_birthday_date" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="patient_place_of_birth">
                      Miejsce urodzenia:
                    </label>
                    <validation-provider
                      rules="required"
                      name="place_of_birth"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_place_of_birth" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <div class="form-group">
                <label for="patient_pesel">
                  PESEL:
                </label>
                <validation-provider
                  rules="required"
                  name="pesel"
                  v-slot="{ errors }">
                  <d-input
                    type="number"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.patient_pesel" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-row>
                <d-col cols="2" md="2" lg="6">
                  <div class="form-group">
                    <label for="patient_city">
                      Miasto:
                    </label>
                    <validation-provider
                      name="city"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_city" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="2" md="2" lg="6">
                  <div class="form-group">
                    <label for="patient_post_code">
                      Kod pocztowy:
                    </label>
                    <validation-provider
                      name="post_code"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_post_code" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="patient_street">
                      Ulica:
                    </label>
                    <validation-provider
                      name="street"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_street" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="patient_number_home">
                      Numer domu:
                    </label>
                    <validation-provider
                      name="number_home"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_number_home" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="patient_number_local">
                      Numer lokalu:
                    </label>
                    <validation-provider
                      name="number_local"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        format="[0-9]{2}\-[0-9]{3}"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.patient_number_local" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Dane szkoły">
            <h4 class="mb-3 pb-3 border-bottom">
              Szkoła dziecka
              <span class="custom-priority">
                <d-checkbox
                  inline
                  v-model="data.priorityNew"
                  toggle
                  class="checkbox-toggle-red">
               {{'Ważność wizyty: '}} <span style="font-weight: 700">{{( data.priorityNew !== true ) ? 'Nie' : 'Tak'}}</span>
              </d-checkbox>
              </span>
            </h4>
            <validation-observer ref="reservation-school-form" tag="form">
              <d-row>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="school_name">
                      Nazwa:
                    </label>
                    <validation-provider
                      rules="required"
                      name="school_name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.school_name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="2" lg="6">
                  <div class="form-group">
                    <label for="school_class">
                      Klasa:
                    </label>
                    <validation-provider
                      rules="required"
                      name="school_class"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.school_class" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="2" md="2" lg="6">
                  <div class="form-group">
                    <label for="school_city">
                      Miasto:
                    </label>
                    <validation-provider
                      name="school_city"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.school_city" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="2" md="2" lg="6">
                  <div class="form-group">
                    <label for="school_postcode">
                      Kod pocztowy:
                    </label>
                    <validation-provider
                      name="school_postcode"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.school_postcode" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="school_street">
                      Ulica:
                    </label>
                    <validation-provider
                      rules="required"
                      name="school_street"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.school_street" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="school_street_number">
                      Numer:
                    </label>
                    <validation-provider
                      rules="required"
                      name="school_street_number"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.school_street_number" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="4">
                  <div class="form-group">
                    <label for="school_street_local_number">
                      Numer lokalu:
                    </label>
                    <validation-provider
                      name="number_local"
                      v-slot="{ errors }">
                      <d-input
                        type="text"
                        format="[0-9]{2}\-[0-9]{3}"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.school_street_local_number" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Dodatkowe informacje">
            <h4 class="mb-3 pb-3 border-bottom">
              Dodatkowe informacje
              <span class="custom-priority">
                <d-checkbox
                  inline
                  v-model="data.priorityNew"
                  toggle
                  class="checkbox-toggle-red">
                {{'Ważność wizyty: '}} <span style="font-weight: 700">{{( data.priorityNew !== true ) ? 'Nie' : 'Tak'}}</span>
              </d-checkbox>
              </span>
            </h4>
            <validation-observer ref="reservation-more-form" tag="form">
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  :name="'institution_id'"
                  v-slot="{ errors }">
                  <div class="form-group">
                    <label class="title-box" :for="data.institution_id">
                      Poradnia:
                    </label>
                    <v-select
                      class="reservation-style reservation-style-select-max"
                      :options="institutions"
                      :reduce="institution => institution.id"
                      v-model="data.institution_id"
                      label="id">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.institution_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  :name="'service_id'"
                  v-slot="{ errors }">
                  <div class="form-group">
                    <label class="title-box" :for="data.service_id">
                      Usługa:
                    </label>
                    <v-select
                      :key="serviceKey"
                      class="reservation-style reservation-style-select-max"
                      :options="services"
                      :reduce="service => service.id"
                      v-model="data.service_id"
                      label="id">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.service_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="reason_name">
                  Powód:
                </label>
                <validation-provider
                  name="reason_name"
                  v-slot="{ errors }">
                  <multi-select
                    :multiple="true"
                    placeholder="Wybierz..."
                    :options="reasons"
                    v-model="data.reason"
                    :track-by="'id'"
                    label="name"
                    select-label="Wybierz"
                    deselectLabel="Usuń wybór"
                    selectedLabel="Wybrane"
                  />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div v-if="data.reason_conditional_field === 1">
                <p>Posiada zaświadczenie lekarskie</p>
              </div>
              <div class="form-group">
                <label for="diagnosis_name">
                  Diagnoza:
                </label>
                <validation-provider
                  name="diagnosis_name"
                  v-slot="{ errors }">
                  <d-input
                    :disabled="true"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.diagnosis_name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group" v-if="data.additional_info && data.additional_info.trim() !== ''">
                <strong>Dodatkowe informacje</strong>
                <p style="font-weight: normal;">{{ data.additional_info }}</p>
              </div>
              <div class="form-group">
                <label for="medical_information">
                  Dodatkowe uwagi sekretariatu (niewidoczne dla pacjenta):
                </label>
                <validation-provider
                  name="medical_information"
                  v-slot="{ errors }"
                >
                  <textarea
                    id="medical_information"
                    class="form-control"
                    :disabled="false"
                    v-model="data.medical_information"
                    rows="4"
                  ></textarea>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
        <div style="width: 100%; text-align: center">
          <d-button
            v-if="!visibleButtonsVisit"
            class="mb-4 mb-3"
            style="width: 30%"
            theme="success"
            @click.prevent="submitForm">
            Zapisz zmiany
          </d-button>
        </div>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from '../../utils/FormUtils.js';
import VisitsFormPatientPopup from './Visits/VisitsFormPatientPopup';
import VisitsFormPopup from './Visits/VisitsFormPopup';
import ListUtils from '../../utils/ListUtils.js';
import Vue from 'vue';
import multiSelect from 'vue-multiselect';
import SexTypes from '@/data/sex-types.js';
import GuardianTypes from '@/data/guardian-types.js';

export default {
  name: 'reservation-list-form',
  components: {
    multiSelect,
    VisitsFormPopup,
    VisitsFormPatientPopup
  },
  computed: {
    reservationPriorities () {
      return [
        {
          id: 0,
          name: 'NIE'
        },
        {
          id: 1,
          name: 'TAK'
        }
      ];
    },
    guardianTypes () {
      return GuardianTypes;
    },
    allDataLoaded () {
      return this.loaded || this.loadedReservation;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    sexTypes () {
      return SexTypes;
    }
  },
  data() {
    return {
      reasons: [],
      data: {
        id: '',
        patient_id: '',
        status: '',
        type: '',
        priorities: '',
        priority: '0',
        priorityNew: false,
        guardian_type: '',
        guardian_name: '',
        guardian_last_name: '',
        guardian_phone: '',
        guardian_email: '',
        guardian_street: '',
        guardian_number_home: '',
        guardian_number_local: '',
        guardian_city: '',
        guardian_post_code: '',
        guardian_pesel: '',
        patient_name: '',
        patient_last_name: '',
        patient_pesel: '',
        patient_sex: '',
        patient_birthday_date: '',
        patient_place_of_birth: '',
        patient_street: '',
        patient_number_home: '',
        patient_number_local: '',
        patient_city: '',
        patient_post_code: '',
        school_class: '',
        school_name: '',
        school_street: '',
        school_street_number: '',
        school_street_local_number: '',
        school_postcode: '',
        school_city: '',
        institution_id: '',
        diagnosis: '',
        reason: '',
        reason_name: '',
        diagnosis_name: '',
        different_fields: [],
        institutions: [],
        singlePatient: [],
        guardian_second_phone: '',
        guardian_second_email: '',
        service_id: '',
        additional_info: '',
        reason_conditional_field: 0,
        medical_information: '',
      },
      loaded: false,
      visibleButtons: false,
      loadError: false,
      // reservations: [],
      service_idCopy: '',
      patients: [],
      visits: [],
      institutions: [],
      services: [],
      loadedReservation: false,
      openBox: false,
      spinnerFormPopup: false,
      showModalVisit: false,
      spinnerPopup: false,
      isModalPatientInfoVisible: false,
      visibleButtonsVisit: false,
      downloading: false,
      visitsFormPopupKey: 0,
      serviceKey: 0,
      dataStatusKey: 0,
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
    // this.loadAdditionalData();
    this.getInstitutionsList();
    this.checkingPatients();
    this.checkingVisits();
    this.loadReasons();
  },
  watch: {
    'data.priority': function (value) {
      this.data.priorityNew = value === 1;
    },
    'data.institution_id': function () {
      this.getServicesList();
      this.serviceKey += 1;
    },
    'data': function () {
      this.checkingPatients();
    },
    'showModalVisit': function () {
      this.visitsFormPopupKey += 1;
    },
  },
  methods: {
    getVisitValue () {
      if (!this.data.service_id) {
        Vue.swal({
          title: 'Musisz wybrać usługę aby móc wyznaczyć termin wizyty.',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
      } else {
        this.spinnerFormPopup = true;
        this.getInstitutionsList();
        setTimeout(() => {
          this.spinnerFormPopup = false;
          this.showModalVisit = true;
        }, 400);
      }
    },
    closeVisitValue () {
      this.showModalVisit = false;
    },
    openBoxFunction () {
      this.openBox = !this.openBox
    },
    showModalInfoPatient() {
      this.spinnerPopup = true;
      setTimeout(() => {
        this.isModalPatientInfoVisible = true;
        this.spinnerPopup = false;
      }, 1000);
    },
    closeModalPatientInfo() {
      this.isModalPatientInfoVisible = false;
    },
    checkingPatients () {
      const reservationID = this.$route.params.id;
      this.$http.post('/patients/reservation-list/is-used-by-patient/' + reservationID, {}, {})
        .then(response => {
          this.visibleButtonsVisit = response.data.is_used;
        })
        .catch(error => {
          console.log(error);
        });
    },
    checkingVisits () {
      const reservationID = this.$route.params.id;
      this.$http.post('/patients/reservation-list/is-used-at-visit/' + reservationID, {}, {})
        .then(response => {
          this.visibleButtonsVisit = response.data.is_used;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/patients/reservation-list/item/',
        instanceFields: ['id', 'patient_id', 'status', 'type', 'guardian_type', 'guardian_name', 'guardian_last_name', 'guardian_phone', 'guardian_email', 'guardian_street', 'guardian_number_home', 'guardian_number_local', 'guardian_city',
          'guardian_post_code', 'guardian_pesel', 'patient_name', 'patient_last_name', 'patient_pesel', 'patient_birthday_date', 'patient_place_of_birth', 'patient_street', 'patient_number_home', 'patient_street', 'patient_number_home',
          'patient_number_local', 'patient_city', 'patient_post_code', 'school_class', 'school_name', 'school_street', 'school_street_number', 'school_street_local_number', 'school_postcode', 'school_city', 'institution_id', 'diagnosis', 'reason',
          'reason_name', 'diagnosis_name', 'different_fields', 'institutions', 'patient', 'patient_sex', 'priorities', 'priority', 'guardian_second_phone', 'guardian_second_email', 'service_id', 'additional_info', 'reason_conditional_field', 'medical_information'],
        loadedKey: 'loaded',
        successAction: () => {
          this.service_idCopy = this.data.service_id;
        }
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/reservation-list/items',
        params: {
          pagination: false
        },
        outputKey: 'reservations',
        loadedKey: 'loadedReservation',
        errorKey: 'loadError',
      });
    },
    getInstitutionsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        outputKey: 'institutions',
        params: {
          pagination: false
        },
      });
    },
    getPatientsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/items',
        outputKey: 'patients',
        params: {
          pagination: false
        },
      });
    },
    getServicesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/items?institution_id=' + this.data.institution_id,
        outputKey: 'services',
        params: {
          pagination: false
        },
      });
    },
    getVisitsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/visits/items',
        outputKey: 'visits',
        params: {
          pagination: false
        },
      });
    },
    getPatientToSend () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/patients/reservation-list/item/' + this.$route.params.id,
        outputKey: 'singlePatient',
        params: {
          pagination: false
        },
        successAction: () => {
          this.submitCreatingPatient();
        }
      });
    },
    loadReasons() {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'patients/reservation-list/get-reasons',
        outputKey: 'reasons',
      });
    },
    submitCreatingPatient () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = '/patients/reservation-list/create-patient/' + this.$route.params.id;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano pacjenta',
        successText: 'Wybrany pacjent został dopisany do bazy danych',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja pacjenta nie powiodła się. Spróbuj ponownie.',
        params: {
          reservation_list_id: this.$route.params.id
        },
        successAction: () => {
          this.loadItemData();
          setTimeout(() => {
            this.dataStatusKey += 1;
          }, 100)
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.singlePatient.patient_name,
        priorities: this.singlePatient.priorities,
        priority: this.singlePatient.priorityNew === true ? 1 : 0,
        reservation_list_id: this.$route.params.id,
        last_name: this.singlePatient.patient_last_name,
        sex: this.singlePatient.patient_sex,
        street: this.singlePatient.patient_street,
        number_home: this.singlePatient.patient_number_home,
        number_local: this.singlePatient.patient_number_local,
        city: this.singlePatient.patient_city,
        post_code: this.singlePatient.patient_post_code,
        pesel: this.singlePatient.patient_pesel,
        phone: this.singlePatient.guardian_phone,
        email: this.singlePatient.guardian_email,
        birthday_date: this.singlePatient.patient_birthday_date,
        identification: this.data.identification,
        place_of_birth: this.singlePatient.patient_place_of_birth,
        school_name: this.singlePatient.school_name,
        school_city: this.singlePatient.school_city,
        school_class: this.singlePatient.school_class,
        school_street: this.singlePatient.school_street,
        school_street_number: this.singlePatient.school_street_number,
        school_street_local_number: this.singlePatient.school_street_local_number,
        school_postcode: this.singlePatient.school_postcode,
        guardian_second_phone: this.singlePatient.guardian_second_phone,
        guardian_second_email: this.singlePatient.guardian_second_email,
        service_id: this.singlePatient.service_id
      };
    },
    handleAccepted (reservationID) {
      this.removeInProgress = true;

      ListUtils.AcceptReservationList(this, {
        endpointBase: '/patients/reservation-list/accept/',
        id: reservationID,
        successAction: () => {
          this.removeInProgress = false;
          this.loadItemData();
          setTimeout(() => {
            this.dataStatusKey += 1;
          }, 100)
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    submitForm () {
      let formDataToSend = {
        id: this.data.id,
        patient_id: this.data.patient_id,
        status: this.data.status,
        type: this.data.type,
        priorities: this.data.priorities,
        priority: this.data.priorityNew === true ? 1 : 0,
        guardian_type: this.data.guardian_type,
        guardian_name: this.data.guardian_name,
        guardian_last_name: this.data.guardian_last_name,
        guardian_phone: this.data.guardian_phone,
        guardian_email: this.data.guardian_email,
        guardian_street: this.data.guardian_street,
        guardian_number_home: this.data.guardian_number_home,
        guardian_number_local: this.data.guardian_number_local,
        guardian_city: this.data.guardian_city,
        guardian_post_code: this.data.guardian_post_code,
        guardian_pesel: this.data.guardian_pesel,
        patient_name: this.data.patient_name,
        patient_last_name: this.data.patient_last_name,
        patient_pesel: this.data.patient_pesel,
        patient_sex: this.data.patient_sex,
        patient_birthday_date: this.data.patient_birthday_date,
        patient_place_of_birth: this.data.patient_place_of_birth,
        patient_street: this.data.patient_street,
        patient_number_home: this.data.patient_number_home,
        patient_number_local: this.data.patient_number_local,
        patient_city: this.data.patient_city,
        patient_post_code: this.data.patient_post_code,
        school_class: this.data.school_class,
        school_name: this.data.school_name,
        school_street: this.data.school_street,
        school_street_number: this.data.school_street_number,
        school_street_local_number: this.data.school_street_local_number,
        school_postcode: this.data.school_postcode,
        school_city: this.data.school_city,
        institution_id: this.data.institution_id,
        diagnosis: this.data.diagnosis,
        reason: this.data.reason,
        reason_name: this.data.reason_name,
        diagnosis_name: this.data.diagnosis_name,
        different_fields: this.data.different_fields,
        institutions: this.data.institutions,
        singlePatient: this.data.singlePatient,
        guardian_second_phone: this.data.guardian_second_phone,
        guardian_second_email: this.data.guardian_second_email,
        service_id: this.data.service_id,
        medical_information: this.data.medical_information
      };
      let endpointUrl = '/patients/reservation-list/update/' + this.$route.params.id;

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano rezerwacje',
        successText: 'Wybrana rezerwacja została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje placówki nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          window.location.reload();
        }
      });
    },
    download (reservationID) {
      this.downloading = true;
      this.$http.post('/patients/reservation-list/get-file/' + reservationID, {}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'rezerwacja-nr-';
        link.setAttribute('download', filename + reservationID + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloading = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.downloading = false;
      });
    }
  }
}
</script>

<style lang="scss">
  .custom-priority {
    font-size: 1rem;
    float: right;
    .custom-control-input:checked ~ .custom-control-label::before {
      background: #c4183c !important;
      border-color: #c4183c !important;
    }
    .custom-control-input:checked ~ .custom-control-label::after {
      background: #fff !important;
    }
    .custom-control-input ~ .custom-control-label::before {
      border-color: #c4183c !important;
    }
    .custom-control-input ~ .custom-control-label::after {
      background: #c4183c !important;
    }
  }
  .reservation-form-box {
    box-shadow: 0 0 10px rgba(24, 29, 39, .1), 0 15px 30px rgba(24, 29, 39, .1), 0 5px 10px rgba(24, 29, 39, .05);
    padding: 2rem;
    border-radius: 10px;
    margin: 2rem 1rem;
  }
  .differentFields-button {
    margin-left: 4rem;
    padding: 0.5rem;
    border-radius: 40px;
    transition: all 0.5s ease;
    transform: rotate(180deg);
    i {
      font-size: 1.5rem;
      color: #fff;
      margin-left: 0 !important;
      padding: 0 !important;
    }
    &:hover i {
      color: #000 !important;
    }
    &--transform {
      transition: all 0.5s ease;
      transform: rotate(0deg);
      i {
        margin-left: 0 !important;
        padding: 0 !important;
      }
    }
  }
  .differentFields-head {
    display: block;
    font-size: 2rem;
  }
  .differentFields-text {
    font-weight: 100;
    font-size: 1.2rem;
    display: inline-flex;
    margin-top: 1rem;
  }
  .differentFields-ul {
    list-style: circle;
    transition: all 0.2s ease;
    margin: 1rem 0;
    height: auto;
    li {
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
    }
    &--transform {
      transition: all 0.2s ease;
      opacity: 0;
      height: 0;
    }
  }
  .sticky-box {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 1rem;
    margin-left: -10%;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 10px rgba(24, 29, 39, .1), 0 15px 30px rgba(24, 29, 39, .1), 0 5px 10px rgba(24, 29, 39, .05);
    padding: 2rem;
    button {
      padding: 1rem 2rem;
    }
  }
  .dropdownStatusMargin {
    .dropdown-menu {
      margin-left: -5rem !important;
    }
  }
  .multiselect__select {
    height: 40px;
  }
</style>
